import React from 'react';

import { getPublicCDNLink } from '@lumirental/lumi-web-shared/lib/utils/cdnLinks';

import IRContainer from '@/company/IR/containers/IRContainer';
import IRLayout from '@/company/IR/Layout/IRLayout';
import SEOTitle from '@/components/SeoTitle';

export async function getServerSideProps() {
  const appEnv = process.env.APP_ENV;
  const cdnLink = getPublicCDNLink('/ir/ir-reports.json', appEnv);
  const res = await fetch(cdnLink);
  const { reportsList } = await res.json();

  return {
    props: {
      reportsList,
    },
  };
}

export default function IR({ store, reportsList }) {
  const pageSEOMetaData = store.appStore.config.getPageSEOMetaData('ir');

  return (
    <>
      <SEOTitle pageSEOMetaData={pageSEOMetaData} />
      <IRLayout>
        <IRContainer reportsList={reportsList} />
      </IRLayout>
    </>
  );
}
